import React, { useState, useEffect } from 'react'
import { FullScreenButton, useGameDisplay } from '../components/GameDisplay';
import Icon from '../components/Icon';
import ContentCard from '../components/game_container/ContentCard';
import NavButtons from '../components/game_container/NavButtons';
import UpdateScore from '../components/game_container/UpdateScore';
import { Link, useParams } from 'react-router-dom';
import { CreativeTVLink } from '../components/CreativeDisplayBridge';

function GamePlayPage() {
    const [currentCardType, setCurrentCardType] = useState(null);
    const [, refresh] = useState(0);
    const { urlGameCode } = useParams();
    const display = useGameDisplay(true, currentCardType);

    useEffect(() => {
        const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
        if (storedLocalData) { 
            setCurrentCardType(storedLocalData.currentCardType); // may need to put outside if statement
        } else {
            console.log('No local data found');
        }
    }, [urlGameCode, setCurrentCardType]);
    useEffect(() => {
      const update = () => { const data = JSON.parse(localStorage.getItem(urlGameCode + '_data') || '{}'); setCurrentCardType(data.currentCardType); refresh(n => n + 1); };
      window.addEventListener('creative-turn', update); window.addEventListener('storage', update); window.addEventListener('focus', update);
      return () => { window.removeEventListener('creative-turn', update); window.removeEventListener('storage', update); window.removeEventListener('focus', update); };
    }, [urlGameCode]);

    return (
        <section className="play-page creative-play-page">
            <div className="play-top"><Link className="back-link" to="/" aria-label="Save and exit"><Icon name="arrow-left" /> Exit</Link><FullScreenButton display={display} /></div>
            <div className="play-content" ref={display.contentRef} tabIndex={0} role="region" aria-label="Current card"><CreativeTVLink code={urlGameCode} /><ContentCard /></div>
            <div className="play-dock">
            {currentCardType === 'prompt' &&
                <NavButtons
                    setCurrentCardType={setCurrentCardType}
                />
            }
            {currentCardType === 'guess' &&
                <UpdateScore
                    setCurrentCardType={setCurrentCardType}
                />
            }
            </div>
        </section>
    )
}

export default GamePlayPage
